<template lang="pug">
  .row.center.img-container.relative
    img.profile-img.absolute(
      v-for='(element, idx) in truncatedElementList'
      :key='element.userId'
      :src='element.avatar || avatarDefault'
      :style='setLeftAndZIndex(idx)'
      alt='profile-avatar'
      v-tooltip.bottom="{ content: element.fullName, classes: 'profile-user-tooltip' }"
    )
    span.more-elements.row.middle.center.absolute(v-if='showMoreElement' :style='setLeftAndZIndex(truncatedElementList.length)')
      | {{ `+${numberOfHiddenAvatars}` }}
    router-link.add.row.middle.center.absolute(
      type='button'
      :style='setLeftAndZIndex(getAddPosition(showMoreElement))'
      v-tooltip.bottom="{content: tooltipContent, classes: 'profile-user-tooltip'}"
      :to='{name: routes.team, params: {schoolId: currentSchool.id}}'
    )
      simple-svg.blue-icon(:filepath='isTeacher ? eyeIcon : addIcon' :width='"22px"' :height='"22px"')
</template>

<script>
import { mapActions, mapState } from 'vuex'

import eyeIcon from '@/assets/ic_eye_on.svg'
import addIcon from '@/assets/ic_add.svg'
import avatarDefault from '@/assets/empty_profile.svg'

import { avatarListLimit, firstElement } from '../../utils/constants'
import userRole from '@/mixins/userRole'
import { i18n } from '../../main'
import { routes } from '../../router'

export default {
  mixins: [userRole],
  data() {
    return {
      routes,
      addIcon,
      eyeIcon,
      avatarDefault
    }
  },
  computed: {
    ...mapState({
      currentSchool: state => state.profile.userProfile.schoolGroupVO.currentSchool
    }),
    showMoreElement() {
      return this.elementsList.length > avatarListLimit
    },
    numberOfHiddenAvatars() {
      return this.elementsList.length - avatarListLimit
    },
    truncatedElementList() {
      return this.elementsList.slice(firstElement, avatarListLimit)
    },
    tooltipContent() {
      return this.isTeacher
        ? i18n.t('profile.schoolTab.seeTeamTooltip')
        : i18n.t('profile.schoolTab.manageTeamTooltip')
    }
  },
  methods: {
    ...mapActions([ 'showElement' ]),
    setLeftAndZIndex(position) {
      return {
        '--left': `${position * 44}px`,
        '--z-index': 1 - position
      }
    },
    getAddPosition(hasMoreElement) {
      return hasMoreElement ? this.truncatedElementList.length + 1 : this.truncatedElementList.length
    }
  },
  props: {
    usersType: { type: Number, required: true },
    elementsList: { type: Array, required: true, default: () => [] },
    avatarTeam: { type: String }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

%default-list-element {
  border: 1px solid $light-gray;
  border-radius: 100%;
  box-sizing: border-box;
  height: 52px;
  left: var(--left);
  width: 52px;
  z-index: var(--z-index);
}

.img-container{
  z-index: 1;
}

.profile-img {
  @extend %default-list-element;
  object-fit: cover;
}

.more-elements {
  @extend %default-list-element;
  background-color: $light-gray;
}

.add {
  @extend %default-list-element;
  border: 2px solid $blue;
  width: 50px;
  height: 50px;
}
</style>
